import { Logo } from "@/components/Logo";

export const AuthShell = ({ title, subtitle, children }) => (
  <div className="grid min-h-screen lg:grid-cols-2">
    <div className="flex flex-col px-6 py-8 sm:px-12">
      <Logo />
      <div className="mx-auto flex w-full max-w-sm flex-1 flex-col justify-center py-12 rise">
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-stone-900">{title}</h1>
        <p className="mt-2 text-sm text-stone-600">{subtitle}</p>
        <div className="mt-8">{children}</div>
      </div>
    </div>
    <div className="relative hidden lg:block">
      <img src="https://images.unsplash.com/photo-1758518729685-f88df7890776?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1400" alt="Team" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-slate-900/55" />
      <div className="absolute bottom-12 left-12 right-12 text-white">
        <p className="font-display text-3xl font-extrabold leading-tight">“We built our entire support team through the portal in under three weeks.”</p>
        <p className="mt-4 text-sm text-stone-300">— Member, home services business</p>
      </div>
    </div>
  </div>
);
